"use client";

interface FixedApplyButtonProps {
	googleFormUrl: string;
}

export const FixedApplyButton = ({ googleFormUrl }: FixedApplyButtonProps) => {
	const handleClick = (): void => {
		window.open(googleFormUrl, "_blank", "noopener,noreferrer");
	};

	return (
		<button
			type="button"
			onClick={handleClick}
			className="
				bg-suzuka2025darkPurple 
				hover:bg-suzuka2025purple 
				text-white 
				font-bold 
				font-zenMaru 
				px-4 
				py-6 
				rounded-lg 
				transition-all 
				duration-300 
				ease-in-out
				transform 
				hover:scale-105
				shadow-lg 
				hover:shadow-xl
				flex
				flex-col
				items-center
				justify-center
				min-w-[80px]
				min-h-[100px]
				text-sm
				leading-tight
			"
		>
			<span>応募</span>
			<span>する</span>
		</button>
	);
};
